module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', {
    style: ('height: ' + _vm.height)
  }, [_c('el-col', {
    attrs: {
      "align": "center",
      "span": 24
    }
  }, [_c('events-calendar', {
    attrs: {
      "events": _vm.selEvents
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "align": "center",
      "span": 24
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.calview),
      callback: function($$v) {
        _vm.calview = $$v
      },
      expression: "calview"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Maintenance",
      "disabled": "",
      "no-form": ""
    }
  }, [_c('span', {
    staticClass: "event-tickets event-legend"
  }, [_vm._v("   ")]), _vm._v(" Maintenance")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Preventive",
      "disabled": "",
      "no-form": ""
    }
  }, [_c('span', {
    staticClass: "event-preventive event-legend"
  }, [_vm._v("   ")]), _vm._v(" Preventive")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Equipment",
      "disabled": "",
      "no-form": ""
    }
  }, [_c('span', {
    staticClass: "event-assets event-legend"
  }, [_vm._v("   ")]), _vm._v(" Equipment")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23254b18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maintenance/MaintCalendar.vue
// module id = 1372
// module chunks = 0